<template>
  <popup @close-popup="closePopup">
    <template v-slot:content>
      <div class="access">
        <div class="access-container">
          <div class="access-container_content">
            <img class="access-container_content__icon" src="../../assets/icons/Warning.svg" alt="warning" />
            <span class="title"> Access Denied </span>
            <p class="access-container_content__info">You cannot checkout with this option. Contact Admin for further assistance</p>
          </div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script lang="ts" setup>
import Popup from '@/components/cards/popup/index.vue'

const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}
</script>
